import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { isRenewalProposal } from '../../../domain'
import { AppPath } from '../../AppPath'
import { ProposalPath } from '../proposal/ProposalPath'
import { useProposal } from '../proposal/ProposalProvider'
import { RenewalDisclosureRouter, RenewalOptOutPage, RenewalSummaryPage } from './index'

export const RenewalRouter: FunctionComponent = () => {
  const { proposal } = useProposal()

  if (
    !isRenewalProposal(proposal) ||
    proposal.sourcePolicy.detail.renewalStopped ||
    !proposal.sourcePolicy.detail.autoRenewalEnabled
  ) {
    return <Navigate to={AppPath.HOME} />
  }

  return (
    <Routes>
      <Route index element={<RenewalSummaryPage />} />
      <Route path={ProposalPath.OPT_OUT} element={<RenewalOptOutPage />} />

      <Route
        path={ProposalPath.DISCLOSURE + AppPath.WILDCARD}
        element={<RenewalDisclosureRouter />}
      />

      <Route path='*' element={<Navigate to={AppPath.HOME} />} />
    </Routes>
  )
}
